module.exports = __webpack_public_path__ + "static/media/defaultPhoto.3ea9e848.png";